import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

var _templateObject;

import styled from 'styled-components';
import { TypographyTokens } from '@vds-tokens/typography';
import { Fonts } from '@vds-core/typography';
var fontFamily = Fonts.VerizonNHGeTX;
var fontSizeDesktop = TypographyTokens.fontsize.body[12].value;
var lineHeightDesktop = TypographyTokens.lineheight.body[16].value;
var PaginationListItem = /*#__PURE__*/styled.li.withConfig({
  displayName: "PaginationListItem",
  componentId: "VDS__sc-ruawv6-0"
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  font-family: ", ";\n  font-size: ", "; // TODO: Viewport awareness?\n  line-height: ", ";\n  margin-", ": auto;\n  text-align: center;\n"])), fontFamily, fontSizeDesktop, lineHeightDesktop, function (_ref) {
  var marginSide = _ref.marginSide;
  return marginSide;
});
export default PaginationListItem;